/*
 * @Author: WangWenqi
 * @Date: 2024-12-23 14:52:01
 * @Description: 合同管理
 */
import { RoleType } from '../constants';
import ContractList from '../views/contract-list.vue';
import ContractView from '../views/contract-view.vue';

// 列表路由
const listRoutes = [
  {
    path: '/main/asp/contract-mgmt/list',
    name: 'contract-mgmt-list',
    meta: {
      title: '合同管理',
      role: RoleType.ASP,
      roleText: 'asp'
    },
    component: ContractList
  },
  {
    path: '/main/industry/contract-mgmt/list',
    name: 'contract-mgmt-industry-list',
    meta: {
      title: '合同管理',
      role: RoleType.INDUSTRY,
      roleText: 'industry'
    },
    component: ContractList
  },
  {
    path: '/main/supplier/contract-mgmt/list',
    name: 'contract-mgmt-supplier-list',
    meta: {
      title: '合同管理',
      role: RoleType.SUPPLIER,
      roleText: 'supplier'
    },
    component: ContractList
  },
  {
    path: '/main/base/contract-mgmt/list',
    name: 'contract-mgmt-base-list',
    meta: {
      title: '合同管理',
      role: RoleType.BASE,
      roleText: 'base'
    },
    component: ContractList
  }
];

// 创建上传、查看路由
const createSecRoute = parentRoutes => {
  return parentRoutes.reduce((pre, cur) => {
    pre.push({
      path: `/main/contract-mgmt/${cur.meta.roleText}/view`,
      meta: {
        title: '查看合同',
        parentPath: cur.path,
        role: cur.meta.role,
        roleText: cur.meta.roleText
      },
      component: ContractView
    });

    return pre;
  }, []);
};

export const route = [...listRoutes, ...createSecRoute(listRoutes)];
